/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IoCloseSharp } from 'react-icons/io5';
import Store from '../../store/store';
import { openModal } from '../../actions/modalActions';
import modalTypes from '../../constants/modalTypes';
import Holon from '../Buttons/holon';
import Dropdown from '../Buttons/dropdown';
import { resultCardId } from '../../utils/string';
import { allows } from '../../utils/authorization';

class DetailHeader extends React.Component {
  constructor(props) {
    super(props);
    const vtrs = props.item.result_type
      ? props.item.result_type.type_attributes
      : {};
    this.state = {
      value: vtrs.value,
      tc: vtrs.tc,
      rroe: vtrs.rroe,
      size: vtrs.size,
      showHolon: false
    };
    this.handleWorkPackageBlock = this.handleWorkPackageBlock.bind(this);
    this.handleWorkPackageRemove = this.handleWorkPackageRemove.bind(this);
    this.handleWorkPackageDelete = this.handleWorkPackageDelete.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.sumSizePoints = this.sumSizePoints.bind(this);
    this.toggleHolon = this.toggleHolon.bind(this);
    this.openParent = this.openParent.bind(this);
    this.handleWorkPackageRestore = this.handleWorkPackageRestore.bind(this);
  }

  handleWorkPackageBlock(blockStatus) {
    const payload = { blocked: blockStatus };
    this.props.handleUpdate(payload);
  }

  handleWorkPackageDelete() {
    this.props.handleDelete(this.props.item.id);
    this.props.onClose();
  }

  handleWorkPackageRemove() {
    this.props.handleRemove(this.props.item.id, this.props.cadence);
  }

  handleWorkPackageRestore() {
    this.props.handleRestore(this.props.item.id);
    this.props.onClose();
  }

  handleSelectChange(event) {
    event.preventDefault();
    const vtrs = this.state;
    vtrs[event.target.name] = event.target.value;
    const payload = {
      type_attributes: {
        value: vtrs.value,
        tc: vtrs.tc,
        rroe: vtrs.rroe,
        size: vtrs.size
      }
    };
    this.setState(vtrs, () => {
      if (this.props.item.id) {
        this.props.handleUpdate(payload);
      } else {
        this.props.handleTypeAttributes(payload.type_attributes);
      }
    });
  }

  sumSizePoints(stories) {
    return stories.reduce(
      (acc, cur) =>
        acc +
        ((cur.result_type &&
          parseInt(cur.result_type.type_attributes.size, 10)) ||
          0),
      0
    );
  }

  toggleHolon(show) {
    this.setState({ showHolon: show });
  }

  openParent() {
    const { item, type } = this.props;
    let modalType = modalTypes.featureDetail;
    if (item.level === 2) modalType = modalTypes.capabilityDetail;
    if (item.level === 3) modalType = modalTypes.epicDetail;

    if (item.parent_id) {
      Store.dispatch(
        openModal(modalType, { id: item.parent_id, fromChild: true })
      );
    }
  }

  render() {
    const { value, tc, rroe, size, showHolon } = this.state;
    const {
      item,
      stories,
      options,
      title,
      fromChild,
      onClose,
      selectedSpace,
      changeOrgLevel
    } = this.props;
    const allowEdit = allows('update', item);
    const allowDelete = allows('destroy', item);
    const allowRestore = allows('restore_work_packages', item) || true; // temporary hack - fixed on rails 6 branch
    const valueOptions =
      (options.value_defaults && options.value_defaults.values) || {};
    const riskOptions =
      (options.risk_defaults && options.risk_defaults.values) || {};
    const sizeOptions =
      (options.t_shirt_size_defaults && options.t_shirt_size_defaults.values) ||
      {};
    const completedStories = stories.filter((story) => story.completed);
    const completedPoints = this.sumSizePoints(completedStories);
    const totalPoints = this.sumSizePoints(stories);

    return (
      <div>
        <div className="col-sm-5">
          <div className="col-sm-1">
            <Dropdown
              blocked={item.blocked}
              handleBlock={this.handleWorkPackageBlock}
              handleRemove={this.handleWorkPackageRemove}
              handleDelete={this.handleWorkPackageDelete}
              handleRestore={this.handleWorkPackageRestore}
              allowDelete={allowDelete}
              allowEdit={allowEdit}
              allowRestore={item.id > 0 ? allowRestore : false}
              type={item.sprint ? item.result_type.kind : ''}
              deleted={item.deleted_at}
              onClose={onClose}
              selectedSpace={selectedSpace}
              result={item}
              changeOrgLevel={changeOrgLevel}
              dropdownType='Result'
            />
          </div>
          <div className="col-sm-2">
            <strong className={`modal-title ${item.blocked ? 'red' : ''}`}>
              {item.id ? resultCardId(item) : title}
            </strong>
          </div>
          <div className="col-sm-8">
            <div className="hours">
              <span>
                # - {completedStories.length}/{stories.length}
              </span>
            </div>
            <div className="hours">
              <span>
                {completedPoints}/{totalPoints} pt{totalPoints === 1 ? '' : 's'}
              </span>
            </div>
          </div>
        </div>
        <div className="col-sm-2 text-center card-holon">
          {!!item.parent_id && (
            <Holon
              action={this.openParent}
              mouseEnter={() => this.toggleHolon(true)}
              mouseLeave={() => this.toggleHolon(false)}
            />
          )}
          {item.has_children && fromChild && (showHolon || !item.parent_id) && (
            <Holon
              action={onClose}
              classes="pointing-down"
              mouseEnter={() => this.toggleHolon(true)}
              mouseLeave={() => this.toggleHolon(false)}
            />
          )}
        </div>
        <div className="col-sm-5 form-inline text-center">
          <div className="col-sm-12 vrs">
            <div className="selected">
              <select
                name="value"
                className="value"
                value={value || '-VALUE-'}
                disabled={!allowEdit}
                onChange={this.handleSelectChange}
              >
                {valueOptions[value] ? (
                  <option value="">--Remove--</option>
                ) : (
                  <option value="">VALUE</option>
                )}
                {Object.keys(valueOptions).map((key) => (
                  <option key={key} value={key}>
                    {key}
                  </option>
                ))}
              </select>
            </div>
            <div className="selected">
              <select
                name="tc"
                className="tc "
                value={tc || '-TC-'}
                disabled={!allowEdit}
                onChange={this.handleSelectChange}
              >
                {riskOptions[tc] ? (
                  <option value="">--Remove--</option>
                ) : (
                  <option value="">TC</option>
                )}
                {Object.keys(riskOptions).map((key) => (
                  <option key={key} value={key}>
                    {key}
                  </option>
                ))}
              </select>
            </div>
            <div className="selected">
              <select
                name="rroe"
                className="risk"
                value={rroe || '-RR/OE-'}
                disabled={!allowEdit}
                onChange={this.handleSelectChange}
              >
                {riskOptions[rroe] ? (
                  <option value="">--Remove--</option>
                ) : (
                  <option value="">RR/OE</option>
                )}
                {Object.keys(riskOptions).map((key) => (
                  <option key={key} value={key}>
                    {key}
                  </option>
                ))}
              </select>
            </div>
            <div className="selected">
              <select
                name="size"
                className="feature-points"
                value={size || '-SIZE-'}
                disabled={!allowEdit}
                onChange={this.handleSelectChange}
              >
                {valueOptions[size] ? (
                  <option value="">--Remove--</option>
                ) : (
                  <option value="">SIZE</option>
                )}
                {Object.keys(sizeOptions).map((key) => (
                  <option key={key} value={key}>
                    {sizeOptions[key]}
                  </option>
                ))}
              </select>
            </div>
            <button type="button" className="btn-close" onClick={onClose}>
              <IoCloseSharp size="2em" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DetailHeader.propTypes = {
  handleUpdate: PropTypes.func,
  handleRemove: PropTypes.func,
  handleDelete: PropTypes.func,
  onClose: PropTypes.func,
  item: PropTypes.object,
  stories: PropTypes.array,
  cadence: PropTypes.number,
  options: PropTypes.object,
  fromChild: PropTypes.bool,
  type: PropTypes.string
};

export default DetailHeader;
